import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
function initMetaPixel() {
  if ((window as any).fbq) return;
  const n: any = (window as any).fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!(window as any)._fbq) (window as any)._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
  (window as any).fbq('init', '961621766258204');
  (window as any).fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <LandingPage data-id="element-0" />;
}